import { useEffect, useState } from "react";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { GET_TICKETS, GET_TICKETS_FOR_EXERCISE } from "../../api/apiRoutes";
import { TicketModel } from "../../models/TicketModel";
import { Assort } from "../../models/Assort";

const setTicket = (title: string, assort: Assort[], bookingGroup: number) => {
  return {
    title,
    assorts: assort.filter((item: Assort) => item.bookingGroup.objectId === bookingGroup)
  } as TicketModel;
};

const ticketType = [
  { bookingGroup: 4, name: "Bilety jednodniowe" },
  { bookingGroup: 5, name: "Bilety popołudniowe" },
  { bookingGroup: 6, name: "Bilety dwudniowe" }
];

export default function useTicketManager(isExercise: boolean) {
  const { get } = useApiRequest();
  const [loading, setLoading] = useState(false);
  const [tickets, setTickets] = useState<TicketModel[]>([]);
  const [assorts, setAssorts] = useState<Assort[]>([]);

  const getTickets = async () => {
    setLoading(true);
    const { result, isError } = await get(isExercise ? GET_TICKETS_FOR_EXERCISE : GET_TICKETS);
    if (!isError) {
      setAssorts(result);
      setTickets(ticketType.map(item => setTicket(item.name, result, item.bookingGroup)));
    }
    setLoading(false);
  };

  useEffect(() => {
    getTickets();
    //eslint-disable-next-line
  }, []);

  return {
    loading,
    tickets,
    assorts
  };
}
